import React from "react"
import { parseLink } from "../helpers/storyblokLinkHandler"

export default {
  h1: (props) => <p className="title__h1">{props.children}</p>,
  h2: (props) => <p className="title__h2">{props.children}</p>,
  h3: (props) => <p className="title__h3">{props.children}</p>,
  h4: (props) => <p className="title__h4">{props.children}</p>,
  h5: (props) => <p className="title__h5">{props.children}</p>,
  h6: (props) => <p className="title__h6">{props.children}</p>,
  a: (props) => {
    const url = parseLink(props.href)
    return (
      <a
        href={url}
        target={url.startsWith("/") ? "" : "_blank"}
        rel={url.startsWith("/") ? "" : "noopener noreferrer"}
      >
        {props.children}
      </a>
    )
  },
}
